import * as Loads from 'react-loads';
import {
  fetchProductById,
  fetchProductBySlug,
  fetchProductIncludeUnpublished,
} from '~/hooks/useProduct/useProductRequests';

export const useProduct = ({
  includeUnpublished = false,
  id,
  slug,
}: {
  includeUnpublished?: boolean;
  id?: string;
  slug?: string;
}) => {
  let request: any = () => Promise.reject();
  let variables: string[] = [];

  if (includeUnpublished) {
    if (id) {
      request = fetchProductIncludeUnpublished;
      variables = [id];
    }
  } else {
    if (id) {
      request = fetchProductById;
      variables = [id];
    } else if (slug) {
      request = fetchProductBySlug;
      variables = [slug];
    }
  }

  return Loads.useLoads<any, any>('productPage', request, {
    variables,
  });
};
